import { render, staticRenderFns } from "./RatingsDashboard.vue?vue&type=template&id=ed1ea5ec&scoped=true&"
import script from "./RatingsDashboard.vue?vue&type=script&lang=js&"
export * from "./RatingsDashboard.vue?vue&type=script&lang=js&"
import style0 from "./RatingsDashboard.vue?vue&type=style&index=0&id=ed1ea5ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed1ea5ec",
  null
  
)

export default component.exports